// @ts-nocheck

(() => {
  "use strict";

  const EL = (globalThis.EspacioLaserV2 =
    globalThis.EspacioLaserV2 || {});

  class EngravingEditor {
    constructor(root, options = {}) {
      if (!(root instanceof Element)) {
        throw new Error(
          "[EspacioLaserV2] EngravingEditor requiere un elemento raíz."
        );
      }

    if (
  !EL.EngravingDOMAdapter ||
  !EL.EngravingState ||
  !EL.EngravingRenderer ||
  !EL.EngravingDrag ||
  !EL.EngravingRotate ||
  !EL.EngravingScale ||
  !EL.EngravingModal
) {
  throw new Error(
    "[EspacioLaserV2] Faltan módulos base del editor."
  );
}

      this.root = root;
      this.options = options;

      this.adapter = new EL.EngravingDOMAdapter(root);
      this.elements = this.adapter.elements;

      this.state = new EL.EngravingState(
        this.adapter.readInitialState()
      );

      this.renderer = new EL.EngravingRenderer({
  state: this.state,
  adapter: this.adapter,
});

this.drag = new EL.EngravingDrag({
  state: this.state,
  elements: this.elements,
});

this.rotate = new EL.EngravingRotate({
  state: this.state,
  elements: this.elements,
});
this.scale = new EL.EngravingScale({
  state: this.state,
  elements: this.elements,
});
this.modal = new EL.EngravingModal({
  state: this.state,
  elements: this.elements,
  root: this.root,
});

this.abortController = new AbortController();

      this.bindBaseEvents();

      this.root.dataset.engravingV2Ready = "true";
      this.root.engravingEditor = this;
    }

    bindBaseEvents() {
      const { signal } = this.abortController;

      const textInput =
        this.elements.textInput ||
        this.root.querySelector(
          "[data-engraving-text-input]"
        );

      if (textInput) {
        // El estado visual "Diseño listo" ahora depende del tipo de
        // personalización elegido (texto, imagen o ambos), no solo del
        // texto, así que lo gestiona assets/personalizer-attachment.js
        // (que ya conoce el tipo seleccionado y el archivo adjunto).
        const actualizarTexto = () => {
          this.state.setText(textInput.value || "");
        };

        textInput.addEventListener(
          "input",
          actualizarTexto,
          { signal }
        );

        textInput.addEventListener(
          "change",
          actualizarTexto,
          { signal }
        );

        actualizarTexto();
      }

      if (this.elements.saveButton) {
        this.elements.saveButton.addEventListener(
          "click",
          () => {
            this.root.dispatchEvent(
              new CustomEvent("engraving:v2:saved", {
                bubbles: true,
                detail: {
                  design: this.getDesign(),
                },
              })
            );
          },
          { signal }
        );
      }

      this.root.addEventListener(
        "engraving:v2:set-text",
        (event) => {
          this.state.setText(
            event.detail?.text || ""
          );
        },
        { signal }
      );

      this.root.addEventListener(
        "engraving:v2:reset-transform",
        () => {
          this.state.resetTransform();
        },
        { signal }
      );
    }

    render() {
      this.renderer.render();
    }

    getDesign() {
      return this.state.toJSON();
    }

    destroy() {
  this.abortController.abort();

  if (this.drag) {
  this.drag.destroy();
}

if (this.rotate) {
  this.rotate.destroy();
}
if (this.scale) {
  this.scale.destroy();
}
if (this.modal) {
  this.modal.destroy();
}

this.renderer.destroy();

  delete this.root.engravingEditor;
  delete this.root.dataset.engravingV2Ready;
}

    static mountAll() {
      const roots = [
        ...document.querySelectorAll(
          "[data-engraving-object]"
        ),
      ]
        .map((object) => {
          return (
            object.closest(".el-personalizer") ||
            object.closest(
              "product-form-component"
            ) ||
            object.parentElement
          );
        })
        .filter(Boolean)
        .filter(
          (root, index, allRoots) =>
            allRoots.indexOf(root) === index
        );

      return roots.map((root) => {
        if (root.engravingEditor) {
          // La raíz sobrevivió a un re-render (p. ej. morph() tras un
          // cambio de variante): el editor sigue vivo y su estado en
          // memoria es válido, pero el DOM pudo perder el marcador
          // data-engraving-v2-ready, el estilo de transformación o el
          // valor de los inputs ocultos. Se re-renderiza desde el
          // estado existente en vez de crear un editor duplicado.
          root.dataset.engravingV2Ready = "true";
          root.engravingEditor.render();
          return root.engravingEditor;
        }

        return new EngravingEditor(root);
      });
    }
  }

  EL.EngravingEditor = EngravingEditor;

  // Se registra una única vez por carga de página (guardado en el
  // namespace compartido EL para evitar listeners duplicados si este
  // script se evaluara más de una vez).
  if (!EL.__variantSettledListenerBound) {
    document.addEventListener(
      "engraving:v2:variant-settled",
      () => {
        EngravingEditor.mountAll();
      }
    );

    EL.__variantSettledListenerBound = true;
  }
})();